module.exports = __webpack_public_path__ + "static/Proposal-Boards4-855763e45121884e97251ad3334567f8.png";